var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.738 1.13379C11.5831 0.288735 12.9542 0.288735 13.7993 1.13379L15.3667 2.70051C16.2118 3.54629 16.2118 4.91743 15.3667 5.76249L5.26352 15.8657C4.85723 16.272 4.30661 16.5 3.73217 16.5H0.722144C0.32379 16.5 0.000488281 16.1767 0.000488281 15.7783V12.7676C0.000488281 12.1939 0.228531 11.6433 0.634823 11.237L10.738 1.13379ZM12.7788 2.15421C12.4967 1.87277 12.0406 1.87277 11.7584 2.15421L10.4024 3.5102L12.9903 6.09806L14.3463 4.74207C14.6277 4.4599 14.6277 4.00382 14.3463 3.72165L12.7788 2.15421ZM11.9699 7.11848L9.38201 4.53063L1.65524 12.2574C1.51957 12.3931 1.4438 12.5764 1.4438 12.7676V15.0567H3.73217C3.92413 15.0567 4.10743 14.9809 4.2431 14.8452L11.9699 7.11848Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.7ffed0329f885d4379c29dbfd7d6ab88.svg";
export { ForwardRef as ReactComponent };